import { ColourConstant, ColourVariants } from '../../api/actions/updateUserConfig';
import { useUserConfigStore } from '../../stores/UserConfigStore';
import CustomStylesheet from './components/Custom';
import DarkStylesheet from './components/Dark';
import LightStylesheet from './components/Light';
import LobeStylesheet from './components/Lobe';
import MatrixStylesheet from './components/Matrix';
import MidnightStylesheet from './components/Midnight';

function getThemeFromLocalStorage(stylesheet: string): ColourVariants {
  // Migrate old default dark theme to lobe on first load
  const fromLocalStorage = localStorage.getItem('stylesheet');
  if (stylesheet === ColourConstant.Dark) {
    if (!fromLocalStorage || fromLocalStorage === ColourConstant.Dark) {
      localStorage.setItem('stylesheet', ColourConstant.Lobe);
      return ColourConstant.Lobe as ColourVariants;
    }
    stylesheet = fromLocalStorage;
  } else {
    // Re-sync when localStorage is not the same as in userConfig
    if (stylesheet !== fromLocalStorage) {
      localStorage.setItem('stylesheet', stylesheet);
    }
  }

  return stylesheet as ColourVariants;
}

const Colours = () => {
  const { userConfig } = useUserConfigStore();
  let stylesheet = userConfig?.stylesheet;

  stylesheet = getThemeFromLocalStorage(stylesheet);

  switch (stylesheet) {
    case ColourConstant.Dark:
      return <DarkStylesheet />;

    case ColourConstant.Matrix:
      return <MatrixStylesheet />;

    case ColourConstant.Midnight:
      return <MidnightStylesheet />;

    case ColourConstant.Light:
      return <LightStylesheet />;

    case ColourConstant.Custom:
      return <CustomStylesheet />;

    case ColourConstant.Lobe:
      return <LobeStylesheet />;

    default:
      return <LobeStylesheet />;
  }
};

export default Colours;
